'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_webclient\uff3fprelude_utils_FirebaseNextOrObserver$() {
}
export { $c_Lapp_webclient\uff3fprelude_utils_FirebaseNextOrObserver$ as $c_Lapp_webclient\uff3fprelude_utils_FirebaseNextOrObserver$ };
$p = $c_Lapp_webclient\uff3fprelude_utils_FirebaseNextOrObserver$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_webclient\uff3fprelude_utils_FirebaseNextOrObserver$;
/** @constructor */
function $h_Lapp_webclient\uff3fprelude_utils_FirebaseNextOrObserver$() {
}
export { $h_Lapp_webclient\uff3fprelude_utils_FirebaseNextOrObserver$ as $h_Lapp_webclient\uff3fprelude_utils_FirebaseNextOrObserver$ };
$h_Lapp_webclient\uff3fprelude_utils_FirebaseNextOrObserver$.prototype = $p;
$p.bDr = (function(f) {
  return ((a) => {
    var this$1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_exts_AOrNullExts$package$().asV(a);
    f.h((this$1.c() ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$() : $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_exts_AOrNullExts$package$().asV(this$1.g())));
  });
});
var $d_Lapp_webclient\uff3fprelude_utils_FirebaseNextOrObserver$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_webclient\uff3fprelude_utils_FirebaseNextOrObserver$, "app.webclient_prelude.utils.FirebaseNextOrObserver$", ({
  IE: 1
}));
export { $d_Lapp_webclient\uff3fprelude_utils_FirebaseNextOrObserver$ as $d_Lapp_webclient\uff3fprelude_utils_FirebaseNextOrObserver$ };
var $n_Lapp_webclient\uff3fprelude_utils_FirebaseNextOrObserver$;
function $m_Lapp_webclient\uff3fprelude_utils_FirebaseNextOrObserver$() {
  if ((!$n_Lapp_webclient\uff3fprelude_utils_FirebaseNextOrObserver$)) {
    $n_Lapp_webclient\uff3fprelude_utils_FirebaseNextOrObserver$ = new $c_Lapp_webclient\uff3fprelude_utils_FirebaseNextOrObserver$();
  }
  return $n_Lapp_webclient\uff3fprelude_utils_FirebaseNextOrObserver$;
}
export { $m_Lapp_webclient\uff3fprelude_utils_FirebaseNextOrObserver$ as $m_Lapp_webclient\uff3fprelude_utils_FirebaseNextOrObserver$ };
//# sourceMappingURL=app.webclient_prelude.utils.-Firebase-Next-Or-Observer$.js.map
